
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.548 20c9.056 0 14.01-7.695 14.01-14.368 0-.22 0-.437-.014-.654.963-.713 1.795-1.6 2.456-2.614a9.617 9.617 0 01-2.827.795A5.052 5.052 0 0023.338.366a9.72 9.72 0 01-3.128 1.226 4.843 4.843 0 00-6.967-.22 5.14 5.14 0 00-1.424 4.826C7.86 5.994 4.17 4.076 1.67.922.364 3.23 1.032 6.181 3.196 7.662a4.795 4.795 0 01-2.236-.63v.063c.001 2.404 1.654 4.474 3.95 4.95a4.78 4.78 0 01-2.222.086c.644 2.058 2.494 3.467 4.6 3.507A9.723 9.723 0 010 17.732a13.692 13.692 0 007.548 2.264","fill":"#BF9C5F","fill-rule":"evenodd"}})])
          )
        }
      }
    